import {writable} from '@convincely/components/src/library.js';

export const loader = writable(0);
export const spinner = writable(false);
export const loaderEndpointFeedback = writable(undefined);

export function loaderStart() {
  loader.update(increment);
}

export function loaderFinish() {
  loader.update(decrement);
  loaderEndpointFeedback.set(undefined);
}

/**
 * @param {number} value
 * @return {number}
 */
function increment(value) {
  return value + 1;
}

/**
 * @param {number} value
 * @return {number}
 */
function decrement(value) {
  return value > 0 ? value - 1 : 0;
}
